module.exports = __webpack_public_path__ + "static/media/creative-process.81e94b12.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/TheMoshiDifference/creative-process.png
// module id = 182
// module chunks = 0